import { render } from "./TicketButton.vue?vue&type=template&id=119e86aa"
import script from "./TicketButton.vue?vue&type=script&lang=js"
export * from "./TicketButton.vue?vue&type=script&lang=js"
script.render = render

export default script